// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class AccountWidgetCoordinates {
    constructor(positionX, positionY) {
        this.positionX = positionX;
        this.positionY = positionY;
    }
}
